import { render, staticRenderFns } from "./DataCurve.vue?vue&type=template&id=fa4ee5c0&scoped=true&"
import script from "./DataCurve.vue?vue&type=script&lang=js&"
export * from "./DataCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4ee5c0",
  null
  
)

export default component.exports